import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

// ✅ Hide all console logs in production (e.g., on Netlify)
if (process.env.NODE_ENV !== 'development') {
  console.log =
    console.warn =
    console.error =
    console.info =
    console.debug =
      () => {};
}

if (process.env.NODE_ENV !== 'development') {
  const noop = () => {};
  console.log = noop;
  console.info = noop;
  console.warn = noop;
  console.error = noop;
  console.debug = noop;
  console.trace = noop;
  console.table = noop;
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
